import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d61ba83"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "windowMessage",
  class: "window-message"
}
const _hoisted_2 = {
  ref: "windowMessage",
  class: "message is-small is-danger"
}
const _hoisted_3 = { class: "message-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Falha de Autenticação", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "message-body" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Nome de usuário ou senha incorretos.")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("article", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("button", {
          class: "delete",
          "aria-label": "delete",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dismissMessage && _ctx.dismissMessage(...args)))
        })
      ]),
      _hoisted_5
    ], 512)
  ], 512))
}